import { InputWrapperProps } from '@mantine/core';
import React from 'react';
import { MeetingTypeDto } from 'src/api/FiretrolApiClient';
import { useMeetingTypes } from 'src/api/queries/jobs/useMeetingTypes';
import { useCreateMeetingType } from 'src/api/queries/meetings/useCreateMeetingType';
import { CreatableSelect } from 'src/design/organisms/CreatableSelect/CreatableSelect';

export interface IMeetingTypeSelectProps
  extends Omit<InputWrapperProps, 'onChange'> {
  jobId: number;
  onChange: (value: MeetingTypeDto | null) => void;
  value: MeetingTypeDto | null;
  disabled?: boolean;
}

export const MeetingTypeSelect: React.FC<IMeetingTypeSelectProps> = ({
  onChange,
  jobId,
  value,
  label = 'Meeting Type',
  placeholder = 'Select or create meeting type...',
  disabled = false,
  ...props
}) => {
  const { data: meetingTypes = [] } = useMeetingTypes(jobId);
  const createMeetingType = useCreateMeetingType(jobId);

  const createNewType = async (name: string) => {
    try {
      return await createMeetingType.mutateAsync(name);
    } catch {
      // The mutation's error pipeline already reported the failure; the select
      // stays open so the user can retry.
      return null;
    }
  };

  return (
    <CreatableSelect
      items={meetingTypes}
      value={value}
      onChange={onChange}
      onCreate={createNewType}
      emptyMessage="No meeting types..."
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      clearValueOnEmptyBlur
      {...props}
    />
  );
};
